class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: '.search-div',
			openSearchButton: '#open-search',
			searchInputWrapper: '.search-input',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('click', this.config.openSearchButton, this.toggleSearch.bind(this));
	}

	toggleSearch(e) {
		e.preventDefault();
		let $target = $(e.currentTarget);

		if($target.data('open') === true) {
			$target.closest(this.config.scope).find(this.config.searchInputWrapper).removeClass('open');
			$target.data('open', false)
		} else {
			$target.closest(this.config.scope).find(this.config.searchInputWrapper).addClass('open');
			$target.closest(this.config.scope).find('[name=q]').focus();
			$target.data('open', true);
		}
	}
}

export default Header;